import React from 'react';
import { Box, BoxProps, Flex, Text } from 'rebass';
import ThirdPanePagination from './ThirdPanePagination';
import ThirdPaneToggle from './ThirdPaneToggle';

export type ThirdPaneHeaderProps = Omit<BoxProps, 'title'> & {
  title: string | JSX.Element;
  onPrev?: () => void;
  onNext?: () => void;
  prevEnabled?: boolean;
  nextEnabled?: boolean;
  forwardedRef?: React.RefObject<HTMLElement>;
  children?: React.ReactNode;
  onToggle?: (visible: boolean) => void;
};

const ThirdPaneHeader = ({
  forwardedRef,
  title,
  onPrev,
  onNext,
  prevEnabled,
  nextEnabled,
  children,
  onToggle,
  ...props
}: ThirdPaneHeaderProps): JSX.Element => {
  return (
    <Box
      {...(props as any)}
      sx={{
        position: 'relative',
        borderBottom: '1px solid',
        borderBottomColor: 'tableBorder',
        zIndex: 3,
        flexGrow: 0,
        ...props.sx,
      }}
      bg="background"
      ref={forwardedRef}
    >
      <Flex justifyContent="space-between" alignItems="center" px={4} py={3}>
        {onToggle && <ThirdPaneToggle visible={true} onToggle={onToggle} />}
        <Text
          variant="heading2"
          sx={{ display: 'flex', gap: 1, alignItems: 'center' }}
        >
          {title}
        </Text>
        <ThirdPanePagination
          prevEnabled={prevEnabled}
          onPrev={onPrev}
          nextEnabled={nextEnabled}
          onNext={onNext}
        />
      </Flex>
      {children && (
        <Box
          px={20}
          pb={3}
          sx={{
            whiteSpace: 'nowrap',
            overflowX: 'auto',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
            '> button': {
              verticalAlign: 'middle',
              marginRight: 2,
              flexShrink: 0,
            },
            '> *:last-child': {
              marginRight: 0,
            },
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  );
};

export default ThirdPaneHeader;
